var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { useAriaLive } from '@ally/use-aria-live';
var widthStyles = {
    s: '30%',
    m: '50%',
    l: '75%',
    xl: '100%',
};
var heightStyles = {
    s: '1rem',
    m: '2rem',
    l: '3rem',
    xl: '4rem',
};
var pulse = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    background: rgba(128, 128, 128, 0.1);\n  }\n  100% {\n    background: rgba(128, 128, 128, 0.2);\n  }\n"], ["\n  0% {\n    background: rgba(128, 128, 128, 0.1);\n  }\n  100% {\n    background: rgba(128, 128, 128, 0.2);\n  }\n"])));
var StyledRow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    animation: ", " 1s ease-in-out alternate infinite both;\n    background: rgba(128, 128, 128, 0.1);\n    margin-bottom: 20px;\n    ", "\n  }\n"], ["\n  && {\n    animation: ", " 1s ease-in-out alternate infinite both;\n    background: rgba(128, 128, 128, 0.1);\n    margin-bottom: 20px;\n    ", "\n  }\n"])), pulse, function (_a) {
    var height = _a.height, width = _a.width;
    return "\n        width: ".concat(widthStyles[width], ";\n        height: ").concat(heightStyles[height], ";\n      ");
});
/**
 * Please do not import this component directly, as the name would be confusing if used without a wrapper
 * See the MDX file for proper usage
 * We are exporting this component here so the interface can be read in the MDX file
 */
export var Container = function (_a) {
    var children = _a.children, _b = _a.isLoading, isLoading = _b === void 0 ? true : _b;
    var announcePolite = useAriaLive().announcePolite;
    useEffect(function () {
        if (isLoading) {
            announcePolite('Loading');
        }
    }, [isLoading, announcePolite]);
    return (React.createElement(React.Fragment, null, isLoading && (React.createElement("section", { "data-testid": "loading-skeleton", "aria-label": "We're loading this section" }, children))));
};
/**
 * Please do not import this component directly, as the name would be confusing if used without a wrapper
 * See the MDX file for proper usage
 * We are exporting this component here so the interface can be read in the MDX file
 */
export var Row = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 's' : _b, _c = _a.width, width = _c === void 0 ? 'xl' : _c;
    return React.createElement(StyledRow, { height: height, width: width });
};
export default { Container: Container, Row: Row };
var templateObject_1, templateObject_2;
//# sourceMappingURL=SkeletonLoader.js.map